module.exports = __webpack_public_path__ + "img/km.km636e9ed.svg";